"use client";

import { SkeletonLoader } from "@/components/ui/skeleton";

// export function AmenitiesSkeleton() {
// 	return (
// 		<div className="grid grid-cols-2 md:grid-cols-3 gap-3">
// 			{Array.from({ length: 6 }).map((_, i) => (
// 				<SkeletonLoader key={i} height="36px" width="100%" className="rounded-full" />
// 			))}
// 		</div>
// 	);
// }

export function NearbySupsSkeleton() {
	return (
		<div className="px-2">
			<div className="flex gap-4 overflow-x-auto py-2">
				{Array.from({ length: 3 }).map((_, i) => (
					<SkeletonLoader key={i} height="180px" width="280px" className="rounded-lg" />
				))}
			</div>
		</div>
	);
}
